import { gql } from "@apollo/client";

export default gql`
  mutation translateAnnouncement($input: TranslateChangelogInput!){
    translateAnnouncement(input: $input){
        success
        data
        error
        message
    }
}
`
